import { useSuspenseQuery } from '@tanstack/react-query';
import type { QueryKey } from '@tanstack/react-query';
import type { QueryConfig } from 'lib/react-query';
import type { Project } from './types';
import { Levels, LevelsParam, } from 'types/shared';
import { apiClient } from 'lib/api';

export interface LevelEntry {
  id: LevelsParam;
  name: Levels;
}

export const getLevels = async (signal?: AbortSignal): Promise<LevelEntry[]> => {
  const res = await apiClient.get<LevelEntry[]>(`/levels`, {
    signal,
  });
  return res.data;
};

interface UseLevelsOptions<TData> {
  config?: QueryConfig<typeof getLevels, TData>;
}

export const useLevels = <TData = Project[]>({ config }: UseLevelsOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getLevels(signal),
    queryKey: ['levels'] as QueryKey,
  });
};
